export const LOCAL_STORAGE_KEYS = {
    // Last Call
    LAST_CALL: {
        key: "v1-lastCall",
        default: null,
        description: "Last call data.",
    },
    AI_CHAT_BUTTON_POSITION: {
        key: "v1-aiChatButtonPosition",
        default: null,
        description: "Last position of the draggable AI chat button on the screen.",
    },
    AI_CHAT_HISTORY: {
        key: "v1-aiChatHistory",
        default: [],
        description: "Chat conversation history with the AI assistant.",
    },
    AI_CHAT_SESSION_ID: {
        key: "v1-aiChatSessionId",
        default: "",
        description: "Current chat session ID for context tracking.",
    },
    // Last Error
    LAST_ERROR: {
        key: "v1-lastError",
        default: "",
        description: "Last error message.",
    },
    // Audio Device Management
    AUDIO_DEVICE_MANAGEMENT: {
        INPUT_DEVICE: {
            key: "v1-audioDeviceManagementInputDevice",
            default: null,
            description: "Input device.",
        },
        OUTPUT_DEVICE: {
            key: "v1-audioDeviceManagementOutputDevice",
            default: null,
            description: "Output device.",
        },
        EVENT_LOG: {
            key: "v1-audioDeviceEventLog",
            default: [],
            description: "Rolling log of the last audio device events (connect, disconnect, switch, selection).",
        },
    },
    // Sidebar
    LEFT_SIDEBAR_OPEN: {
        key: "v1-leftSidebarOpen",
        default: true,
        description: "Whether the left sidebar is open.",
    },
    RIGHT_SIDEBAR_OPEN: {
        key: "v1-rightSidebarOpen",
        default: true,
        description: "Whether the right sidebar is open.",
    },
    // Calendar
    CALENDAR_SEARCH_QUERY: {
        key: "v1-calendarSearchQuery",
        default: "",
        description: "Search query for the calendar.",
    },
    // Notification
    FCM_TOKEN: {
        key: "v1-fcmToken",
        default: "",
        description: "FCM token for notifications.",
    },
    VOICE_REGISTRATION_ID: {
        key: "v1-voiceRegistrationId",
        default: null,
        description: "Stable voice client identity used when FCM is unavailable (e.g. iOS Safari).",
    },
    PENDING_APPOINTMENT_NOTIFICATIONS: {
        key: "v1-pendingAppointmentNotifications",
        default: [],
        description: "Appointment notifications kept until the user dismisses them.",
    },
    PENDING_INCIDENT_NOTIFICATIONS: {
        key: "v1-pendingIncidentNotifications",
        default: [],
        description: "Incident notifications kept until the user dismisses them.",
    },
    // Auth
    AUTH: {
        key: "auth", //! Don't change this key for now
        default: null,
        description: "Auth data.",
    },
    // Call
    CALLED_PHONE_NUMBER: {
        key: "v1-calledPhoneNumber",
        default: "",
        description: "Called phone number.",
    },
    CALLER_PHONE_NUMBER: {
        key: "v1-callerPhoneNumber",
        default: undefined,
        description: "Caller phone number.",
    },
    // Performance
    SELECTED_AGENT_KPI: {
        key: "v1-selectedAgentKpi",
        default: null,
        description: "Last selected agent in member KPIs view.",
    },
    // Calls
    SELECTED_AGENT_CALLS: {
        key: "v1-selectedAgentCalls",
        default: null,
        description: "Last selected agent in calls view.",
    },
    // Reports
    SELECTED_AGENT_REPORTS: {
        key: "v1-selectedAgentReports",
        default: null,
        description: "Last selected agent in performance reports sales summaries.",
    },
};
